/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

export const BaseBlogFragment = gql`
  fragment BaseBlogFragment on Blog {
    __typename
    sys {
      id
    }
    title
    author
    duration
    datePublished
    description
    blogContent {
      json
    }
    blogHeaderMedia {
      url
      title
      description
      contentType
    }
    blogCategory
    url
    # Contentful metadata is not generated by the contentful generate command, so we need to add it manually
    contentfulMetadata {
      tags {
        id
        name
      }
    }
  }
`;
